import Root from './containers/Root';

export default function initPage() {
  return Root;
}
